__turbopack_context__.v({
  "active": "OfflineExperience-module-scss-module__titGDa__active",
  "activeCard": "OfflineExperience-module-scss-module__titGDa__activeCard",
  "card": "OfflineExperience-module-scss-module__titGDa__card",
  "cardsContainerDweb": "OfflineExperience-module-scss-module__titGDa__cardsContainerDweb",
  "cardsContainerMweb": "OfflineExperience-module-scss-module__titGDa__cardsContainerMweb",
  "container": "OfflineExperience-module-scss-module__titGDa__container",
  "headingBlock": "OfflineExperience-module-scss-module__titGDa__headingBlock",
  "imageBlock": "OfflineExperience-module-scss-module__titGDa__imageBlock",
  "mainContainer": "OfflineExperience-module-scss-module__titGDa__mainContainer",
  "textBlock": "OfflineExperience-module-scss-module__titGDa__textBlock",
  "textList": "OfflineExperience-module-scss-module__titGDa__textList",
});
